import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import lottie from 'lottie-web';

Alpine.plugin(focus);
Alpine.plugin(intersect);

/**
 * Tools component
 **************************************************
 * Used for toggling navbar, modals and search
 */

document.addEventListener("alpine:init", () => {

	Alpine.data('tools', () => ({
		navbar: false,
		search: false,
		isScrolling: false,
		overThreshold: false,
		anim: {},
		init() {
			this.buildDrop();

			/**
			 * Black logo animation
			 */
			this.anim.logo = lottie.loadAnimation({
				container: this.$refs.lottieLogo,
				renderer: 'svg',
				loop: false,
				autoplay: true,
				initialSegment: [0, 12],
				path: '/app/themes/cultureword/assets/dist/json/symbol-black.json',
				rendererSettings: {
					progressiveLoad: true,
				}
			});
			this.anim.logo.setSubframe(false);

			/**
			 * Mobile animation
			 */
			this.anim.mob = lottie.loadAnimation({
				container: this.$refs.lottieMob,
				renderer: 'svg',
				loop: false,
				autoplay: true,
				initialSegment: [0, 12],
				path: '/app/themes/cultureword/assets/dist/json/symbol-black.json',
				rendererSettings: {
					progressiveLoad: true,
				}
			});

			if( this.$refs.lottieWordmarkHome ){

				this.anim.wordmarkHome = lottie.loadAnimation({
					container: this.$refs.lottieWordmarkHome,
					renderer: 'svg',
					loop: false,
					autoplay: true,
					initialSegment: [0, 15],
					path: '/app/themes/cultureword/assets/dist/json/wordmark.json',
					rendererSettings: {
						progressiveLoad: true,
					}
				});

			}

		},
		toggleNavbar() {
			this.navbar = !this.navbar;
			this.isScrolling = this.navbar || this.overThreshold;
			if( this.navbar ){
				/**
				 * White logo animation on nav drop
				 */
				this.anim.drop = lottie.loadAnimation({
					container: this.$refs.lottieDrop,
					renderer: 'svg',
					loop: false,
					autoplay: true,
					initialSegment: [0, 12],
					path: '/app/themes/cultureword/assets/dist/json/symbol.json',
					rendererSettings: {
						progressiveLoad: true,
					}
				});
			}else{
				this.anim.drop.destroy();
			}
		},
		toggleSearch() {
			this.search = !this.search;
			this.isScrolling = this.navbar || this.overThreshold;
		},
		reset() {
			this.search = false;
			this.navbar = false;
		},
		buildDrop() {
			let clone = this.$refs.navSource.cloneNode( true );
			clone.classList.remove('hidden');
			clone.removeAttribute('x-ref');
			this.$refs.navTarget.appendChild( clone );
		},
		playWordmark() {
			
			if( this.anim.wordmark ){
				this.anim.wordmark.goToAndPlay(0);
			}else{
				this.anim.wordmark = lottie.loadAnimation({
					container: this.$refs.lottieWordmark,
					renderer: 'svg',
					loop: false,
					autoplay: true,
					initialSegment: [0, 15],
					path: '/app/themes/cultureword/assets/dist/json/wordmark.json',
					rendererSettings: {
						progressiveLoad: true,
					}
				});
			}
			
		}
	}));

});